import React, {useContext, useEffect, useState} from "react";
import {Cookies, useCookies} from "react-cookie";
import {useNavigate} from "react-router-dom";
import {useSanctum} from "react-sanctum";
import {useToolkit} from './useToolkit';
import { v4 as uuidv4 } from 'uuid';

import {auTokenName} from "../config/global";
import {useAuthLocalStorage} from './useAuthLocalStorage';
import {useStockStorage} from "./useStockStorage";


export const useAppUniqueToken = () => {

    const {setAuthLocalStorageKey, removeAuthLocalStorageKey, getAuthLocalStorageKey} = useAuthLocalStorage();
    const {removeSessionStockAll, removeStockStorageToken} = useStockStorage();

    const {getCookieExpiration} = useToolkit();
    const [cookies, setCookie, removeCookie] = useCookies([auTokenName]);
    const {signOut, checkAuthentication, authenticated, user, setUser} = useSanctum();

    let navigate = useNavigate();


    function extendAppUniqueTokenCookieExpiration() {
        let token = cookies[auTokenName];
        setCookie(auTokenName, token, {path: '/', expires: getCookieExpiration(), sameSite: 'lax', httpOnly: false});
    }

    function setAppUniqueToken(token: any) {
        if(!token)
            token = uuidv4();

        setCookie(auTokenName, token, {path: '/', expires: getCookieExpiration(), sameSite: 'lax', httpOnly: false});

        //navigate('/');
    }
    function removeAppUniqueToken(removeALSKey = true) {

        //console.log('removeAppUniqueToken');

        //toast.error('Sessione Terminata!');

        removeCookie(auTokenName);
        if(removeALSKey)
            removeAuthLocalStorageKey();

        //console.log('sanctum authenticated: ' + authenticated);
        //console.log('getAuthLocalStorageKey: ' + getAuthLocalStorageKey());

        removeSessionStockAll();
        removeStockStorageToken();

        signOut()
            .then(() => {
                //console.log('removeAppUniqueToken - signOut OK! - redirect to /landing');
                navigate('/landing');
            })
            .catch((e) => {
                //console.log('removeAppUniqueToken - signOut ERROR: ' +e);

                setUser({}, false);
                navigate('/landing');
            });



/*
        if(authenticated || authLocalStorageSigned)
        {
            signOut()
                .then(() => {
                    console.log('removeAppUniqueToken - signOut OK! - redirect to /');
                    navigate('/');
                })
                .catch((e) => {
                    console.log('removeAppUniqueToken - signOut ERROR: ' +e);

                    setUser({}, false);
                    navigate('/');
                });
        }
*/



        //navigate('/');
        //window.location.reload();
    }

    function getAppUniqueToken() : string {
        if(cookies[auTokenName]) {
            //console.log('getAppUniqueToken: ' + cookies[auTokenName]);
            //console.log('APP-UNIQUE-TOKEN.expires: ' + cookies['APP-UNIQUE-TOKEN'].expires);

            return cookies[auTokenName];
        }
        else
            return '';
    }

    const checkAppUniqueTokenOnStartup = async (path: string) => {
        //console.log('checkAppUniqueTokenOnStartup - PATH: '+path);

        if(cookies[auTokenName]) {
            try {
                //console.log('checkAppUniqueTokenOnStartup - dentro try: ')

                let checkAuthenticationData = await checkAuthentication()
                    .then((response) => {
                        //console.log('checkAuthentication: ' + response);
                        //console.log('ok to navigate to: ' + path);
                        //console.log('---checkAppUniqueTokenOnStartup: user ' + user);

                        navigate(path);
                    }).catch((e) => {
                        console.log('checkAppUniqueTokenOnStartup - ERROR: ' + e);
                        navigate('/');
                    });
            }
            catch(e)
            {
                console.log('checkAppUniqueTokenOnStartup - ERROR2: ' + e);
            }

        }
        else
        {
            console.log('checkAppUniqueTokenOnStartup: token not found or expired');

            removeAuthLocalStorageKey();
            removeSessionStockAll();
            removeStockStorageToken();

            navigate('/');
        }
    };
/*
    function checkAppUniqueTokenOnStartup(path: string) {
        console.log('checkAppUniqueTokenOnStartup - PATH: '+path);

        if(cookies[auTokenName]){

            //console.log('checkAppUniqueTokenOnStartup: token found');
            //console.log('APP-UNIQUE-TOKEN: ' + cookies[auTokenName])

            try {
                console.log('dentro try: ')
                let loungeData = await axios.get('api/lounge')
                    .then(response => {
                        console.log('getLoungeData from axios: ' + response.data.lounge);
                        setData(response.data.lounge);

                        console.log(response.data.lounge);
                    });


                let loungeData = async checkAuthentication()
                    .then((response) => {
                        console.log('checkAuthentication: ' + response);
                        console.log('ok to navigate to: ' + path);
                        console.log('---checkAppUniqueTokenOnStartup: user ' + user);

                        navigate(path);
                    }).catch((e) => {
                    console.log('checkAppUniqueTokenOnStartup - ERROR: ' + e);
                    navigate('/');
                });
            }
            catch(e)
            {
                console.log('checkAppUniqueTokenOnStartup - ERROR2: ' + e);
            }

        }
        else
        {
            console.log('checkAppUniqueTokenOnStartup: token not found or expired');
            removeAuthLocalStorageKey();
            navigate('/');
        }
    }
*/
    function renewAppUniqueToken() {
        setCookie(auTokenName, uuidv4(), {path: '/', expires: getCookieExpiration(), sameSite: 'lax', httpOnly: false});
    }

    return {
        setAppUniqueToken,
        removeAppUniqueToken,
        checkAppUniqueTokenOnStartup,
        extendAppUniqueTokenCookieExpiration,
        getAppUniqueToken,
        renewAppUniqueToken
    }
};

